import React from 'react'
import PropTypes from 'prop-types'
import checkmark_empty from '../../icons/checkmark_empty.png'
import checkmark_full from '../../icons/checkmark_full.png'
import classes from './index.module.css'
import ExplicitTag from '../../GeneralComponents/ExplicitTag'
import PublicationBadge from '../../GeneralComponents/PublicationBadge'

export default function SongListItem({ song, onClick }) {
  const additionalArtists = song.artists
    ?.filter(a => a.f_id !== song.artist?.f_id)
    .map(a => a.name)
    .join(', ') || '—'
  const allIsrcs = [...new Set([
    ...(song.isrc ? [song.isrc] : []),
    ...(song.isrcs ?? []),
  ])]

  function lyricsCell() {
    if (song.is_sync_verified) {
      return (
        <div className={classes.verifiedWrapper}>
          <img width="18" height="18" src={checkmark_full} />
          <span className={classes.statusText}>Sync Verified</span>
        </div>
      )
    }
    if (song.has_lyrics) {
      return <span className={classes.empty}>—</span>
    }
    return <span className={classes.needsLyrics}>Needs Lyrics</span>
  }

  return (
    <tr className={classes.row} onClick={() => onClick(song)}>
      <td className={classes.cell}>
        <div className={classes.songNameCell}>
          <span className={classes.songName}>{song.name}</span>
          {song.is_explicit && <ExplicitTag size="small" />}
        </div>
      </td>
      <td className={classes.cell}>
        <span className={classes.artistName}>{song.song_artist_name || '—'}</span>
      </td>
      <td className={`${classes.cell} ${classes.center}`}>
        {lyricsCell()}
      </td>
      <td className={classes.cell}>
        <PublicationBadge
          size="xs"
          status={song.is_published ? 'published' : 'unpublished'}
          text={song.is_published ? 'Published' : 'Unpublished'}
          className={classes.dimmedBadge}
        />
      </td>
      <td className={classes.cell}>
        {song.alt_song_id
          ? <span className={classes.mono}>{song.alt_song_id}</span>
          : <span className={classes.empty}>—</span>
        }
      </td>
      <td className={classes.cell}>
        <span className={classes.normal}>{additionalArtists}</span>
      </td>
      <td className={classes.cell}>
        {allIsrcs.length
          ? <span className={classes.mono}>{allIsrcs.join(', ')}</span>
          : <span className={classes.empty}>—</span>
        }
      </td>
    </tr>
  )
}

SongListItem.propTypes = {
  song: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
}
